// extracted by mini-css-extract-plugin
export default {"appContainer":"Layout_appContainer__YRQJA","mainContent":"Layout_mainContent__KpSh+"};